import { operators as o } from '@pendo/aggregations';
import { PRODUCT_AREAS, SUB_PRODUCT_AREAS } from '@/utils/aggregation';
const { VOC } = PRODUCT_AREAS || {};
const { CAPTURE } = SUB_PRODUCT_AREAS || {};
import { SOURCES } from '@/voc/constants/feedback';

export default {
    name: 'ConnectSourcesItemCounts',
    productArea: VOC,
    subProductArea: CAPTURE,
    responseFormat: 'rows',
    build ({ sourceConfigs }) {
        const pipeline = o.pipeline(
            o.sources.vocItems({
                appId: 'expandAppIds("*")',
                type: 'feedback',
            }),
            // filter items concerning the connected sources
            o.filter(
                sourceConfigs
                    .map((connectedSource) => {
                        const sourceConfig = SOURCES[connectedSource.objectName];
                        if (sourceConfig && sourceConfig.sourceConfigToVocItemSourceAggFilter) {
                            return sourceConfig.sourceConfigToVocItemSourceAggFilter(connectedSource.objectId);
                        }

                        return 'false';
                    })
                    .join(' || '),
            ),
            // create a new field to map each voc item source to source config
            o.evaluate(
                'sourceConfigId',
                'if(source == "PollResponse" || source == "NPS" , join(split(sourceIdentifier, "")[0:27], ""), if(source == "CSV", split(sourceIdentifier, "  ")[0], if(source == "InternalFeedbackForm", "FeedbackForm", if(source == "QuickCapture", "QuickCapture", if(source == "Portal", sourceIdentifier, if(sourceCategory == "Surveys", sourceIdentifier, source))))))',
            ),
            o.sort('-createdAt'),
            // get counts
            o.group(
                ['sourceConfigId'],
                o.groupField('itemCount', o.count(null)),
                o.groupField('lastItemCapturedAt', { first: 'createdAt' }),
            ),
        );

        return pipeline;
    },
};
